/* PCAS V2: acquisition only; never persist customer form values. */
(function () {
  'use strict';
  const KEY = 'pcas_acquisition_v2';
  const TTL = 90 * 86400000;
  const SESSION = 30 * 60000;
  function cleanURL(raw, base) {
    try { const u = new URL(raw, base); return /^https?:$/.test(u.protocol) ? u.origin + u.pathname : ''; }
    catch (_) { return ''; }
  }
  function touch(href, referrer, now) {
    const u = new URL(href);
    const ref = cleanURL(referrer, href);
    const external = ref && new URL(ref).hostname.replace(/^www\./, '') !== u.hostname.replace(/^www\./, '');
    const get = name => (u.searchParams.get(name) || '').replace(/[\u0000-\u001f]/g, '').slice(0, 160);
    const source = get('utm_source'), medium = get('utm_medium'), campaign = get('utm_campaign');
    let inferred = '(direct)', channel = '(none)';
    if (external) {
      const host = new URL(ref).hostname.replace(/^www\./, '');
      inferred = host;
      channel = /(^|\.)(google\.[a-z.]+|bing\.com|search\.yahoo\.com|duckduckgo\.com)$/.test(host) ? 'organic' : 'referral';
    }
    return { at: now, landing_page: cleanURL(href), referrer: external ? ref : '', utm_source: source,
      utm_medium: medium, utm_campaign: campaign, source: source || inferred, medium: medium || channel,
      acquired: !!(source || medium || campaign || external) };
  }
  function advance(previous, current, now) {
    const valid = previous && previous.version === 2 && previous.first && previous.latest &&
      Number.isFinite(previous.first.at) && Number.isFinite(previous.last_seen) &&
      now >= previous.first.at && now - previous.first.at < TTL;
    const fresh = !valid || now - previous.last_seen >= SESSION;
    const state = valid ? { ...previous } : { version: 2, first: current, latest: current };
    // Internal navigation retains the acquisition; a new direct session is an explicit direct latest touch.
    if (fresh || current.acquired) state.latest = current;
    state.last_seen = now;
    return state;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { touch, advance, cleanURL }; return; }
  if (window.PCAS) return;
  let state = null, allowed = false;
  const captured = touch(location.href, document.referrer, Date.now());
  function storeGet(key) { try { return JSON.parse(localStorage.getItem(key)); } catch (_) { return null; } }
  function syncConsent() {
    allowed = !!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed();
    if (!allowed) {
      state = null;
      try { localStorage.removeItem(KEY); sessionStorage.removeItem('pcas_session_v2'); } catch (_) {}
    } else if (!state) {
      state = advance(storeGet(KEY), captured, Date.now());
      try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {}
    }
    document.dispatchEvent(new CustomEvent('pcas:attribution-ready'));
  }
  function fields() {
    const result = { 'PCAS Attribution Status': allowed ? 'captured' : 'unavailable / consent not granted' };
    if (allowed && state) {
      for (const kind of ['first', 'latest']) {
        for (const key of ['at','source','medium','utm_source','utm_medium','utm_campaign','referrer','landing_page'])
          result['PCAS ' + kind + ' ' + key] = String(state[kind][key] ?? '');
      }
    }
    return result;
  }
  let gaConfigured=false;
  function sendAnalytics(name,payload){
    if(typeof window.gtag!=='function')return;
    if(!gaConfigured){window.gtag('config','G-7MH3F39CD3',{send_page_view:false});gaConfigured=true;}
    let test=false;
    try{if(new URL(location.href).searchParams.get('pcas_test')==='1')sessionStorage.setItem('pcas_metrics_test','1');test=sessionStorage.getItem('pcas_metrics_test')==='1';}catch(_){}
    const params={send_to:'G-7MH3F39CD3',page_location:cleanURL(location.href),page_referrer:cleanURL(document.referrer),pcas_session_id:payload.session_id,test_event:test?'yes':'no'};
    for(const key of ['product_id','inquiry_type','lead_id','cta_location','contact_method','first_source','first_medium','first_campaign','latest_source','latest_medium','latest_campaign']){
      if(payload[key]!==undefined)params[key]=String(payload[key]).slice(0,100);
    }
    if(payload.sold!==undefined)params.product_status=payload.sold?'sold':'available';
    if(test)params.debug_mode=true;
    const eventName=test?name.replace('pcas_','pcas_test_'):name;
    window.gtag('event',eventName,params);
    if(name==='pcas_inquiry_submitted')window.gtag('event',test?'pcas_test_lead_received':payload.inquiry_type==='delivery_quote'?'pcas_quote_received':'pcas_similar_received',params);
  }
  function event(name, data) {
    if (!allowed || window.Shopify?.designMode) return;
    let session; try { session = JSON.parse(sessionStorage.getItem('pcas_session_v2')); } catch (_) {}
    const payload = { event: name, pcas_version: '2', session_id: session?.id || '',
      first_source: state?.first.source || '', first_medium: state?.first.medium || '', first_campaign: state?.first.utm_campaign || '',
      latest_source: state?.latest.source || '', latest_medium: state?.latest.medium || '', latest_campaign: state?.latest.utm_campaign || '', ...data };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try{sendAnalytics(name,payload);}catch(_){}
    try { window.Shopify?.analytics?.publish?.(name, payload)?.catch?.(() => {}); } catch (_) {}
  }
  window.PCAS = { fields, event };
  function productSession() {
    if (!allowed) return;
    const root = document.querySelector('[data-pcas-product]');
    let session;
    try { session = JSON.parse(sessionStorage.getItem('pcas_session_v2')); } catch (_) {}
    const now = Date.now();
    if (!session || now - session.at >= SESSION) session = { id: crypto.randomUUID(), at: now, products: [] };
    if (root && !session.products.includes(root.dataset.pcasProduct)) {
      event('pcas_product_session', { session_id: session.id, product_id: root.dataset.pcasProduct, sold: root.dataset.pcasSold === 'true' });
      session.products.push(root.dataset.pcasProduct);
    }
    session.at = now;
    try { sessionStorage.setItem('pcas_session_v2', JSON.stringify(session)); } catch (_) {}
  }
  document.addEventListener('pcas:attribution-ready', productSession);
  document.addEventListener('DOMContentLoaded', productSession);
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify?.customerPrivacy) syncConsent();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) syncConsent(); });
})();
